







































































































































































































































































import { Component, Mixins, Ref } from 'vue-property-decorator';
import CRUDMixins from '@/mixins/CRUDMixins';
import BodyMapMixins from '@/mixins/BodyMapMixins';
import TransitionMixins from '@/mixins/TransitionMixins';
import RiskProfileOptions from '@/components/RiskProfile/RiskProfileOptions.vue';
import { mapState, mapGetters } from 'vuex';

@Component({
  components: {
    RiskProfileOptions,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('RiskProfileTemplate', {
      selectedTemplate: 'selectedTemplate',
    }),
    ...mapState('RiskProfile', {
      bodyParts: 'bodyParts', // is used in BodyMapMixins
    }),
    ...mapGetters('RiskProfile', {
      enabledRiskProfileItems: 'enabledRiskProfileItems',
      enabledQuestionGroups: 'enabledQuestionGroups',
      bodyPartPreviewItems: 'bodyPartPreviewItems',
    }),
  },
})
export default class RiskProfileTemplateUpdate extends Mixins(
  CRUDMixins,
  BodyMapMixins,
  TransitionMixins
) {
  // RiskProfile State
  selectedTemplate!: Model;

  // Getters
  enabledRiskProfileItems!: [];
  enabledQuestionGroups!: [];
  bodyPartPreviewItems!: [];

  // Data
  currentStep = 0;
  valid = false;
  nameFound = false;
  searchedNames = [];
  dialog = false;
  isMounted = false;
  refreshList = 0;
  selectedOccupations: Model[] = [];
  showPreview = false;
  timer = -1;
  riskProfileTemplateNameRules = [(v) => !!v || 'Required'];
  options = { page: 1, itemsPerPage: 10, query: '' };
  dialogOptions = { page: 1, itemsPerPage: 10, query: '' };
  questionGroupDescription =
    'Here is the list of the question groups the individual will complete which will provide the relevant information in their report.';

  @Ref() readonly step_1!: { validate: (any?: any) => void };

  // Computed
  get riskProfileTemplate() {
    return this.selectedTemplate;
  }
  set riskProfileTemplate(v) {
    this.$store.commit('RiskProfileTemplate/SET_SELECTED_TEMPLATE', v);
  }

  get nameValidMessage() {
    return !this.nameFound ? 'The name is valid' : '';
  }

  get nameInvalidMessage() {
    return this.nameFound ? 'The name exists' : '';
  }

  get steps() {
    return [
      {
        title: 'Step 1',
        subtitle: 'Customise Profile Information',
        canProceed: () => this.valid,
      },
      {
        title: 'Step 2',
        subtitle: 'Link ANZSCO Occupations',
        canProceed: () => this.valid,
      },
      {
        title: 'Step 3',
        subtitle: 'Customise the Risk Profile',
        description:
          "<p>We've set the common actions, work environment conditions, other requirements and PPE for your selected job role based on ANZSCO risk profiling.</p><p>You can tailor any aspect of the risk to meet your organisational needs.</p>",
        canProceed: () => this.valid,
      },
      {
        title: 'Step 4',
        subtitle: 'Review and Update',
        canProceed: () => this.valid,
      },
    ];
  }

  // BeforeMount
  beforeMount() {
    this.$store
      .dispatch('RiskProfileTemplate/fetch', this.$route.params.rptOid)
      .then(() => {
        this.selectedOccupations = this.riskProfileTemplate[
          'anzsco_occupation_list'
        ];
      });
    this.$store
      .dispatch(
        'RiskProfileTemplate/fetchFullRiskProfileTemplate',
        this.$route.params.rptOid
      )
      .then(() => {
        this.isMounted = true;
        // this.$route.meta.appBarActions[0].disabled = true
        this.validateName();
      });
  }

  // BeforeDestroy
  beforeDestroy() {
    this.$store.commit('RiskProfile/CLEAR_STATE');
    this.$store.commit('RiskProfileTemplate/CLEAR_STATE');
  }

  // Methods
  validateName() {
    this.valid = false;
    // this.$route.meta.appBarActions[0].disabled = true
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = -1;
    }

    this.timer = window.setTimeout(() => {
      this.searchForName();
    }, 500);
  }

  async searchForName() {
    if (
      (this.riskProfileTemplate.name &&
        this.riskProfileTemplate.name.length === 0) ||
      !this.riskProfileTemplate.name
    ) {
      if (this.step_1) {
        this.step_1.validate();
        this.valid = false;
      }
      return null;
    }

    this.timer = window.setTimeout(() => {
      this.$store
        .dispatch(
          'RiskProfileTemplate/searchForTemplateName',
          this.riskProfileTemplate.name
        )
        .then(({ data }) => {
          const payload = data.data;
          const index = payload.data.findIndex(
            (x) => x.object_id == this.$route.params.rptOid
          );
          if (index > -1) {
            payload.data.splice(index, 1);
          }
          this.searchedNames = payload.data;
          this.step_1.validate();
          if (payload.data.length === 1) {
            this.nameFound =
              payload.data[0].object_id !== this.$route.params.rptOid;
          } else {
            this.nameFound = payload.data.length > 0;
          }
          if (this.nameFound) {
            this.valid = false;
            this.$emit('disable-actions', ['UPDATE']);
          } else {
            this.valid = true;
            this.$emit('disable-actions', ['']);
          }
        });
    }, 500);
  }

  handleFetchJobList(query, page, itemsPerPage) {
    if (query.length > 2) {
      return this.$store.dispatch('Anzsco/fetchList', {
        params: {
          search_name: query,
          page: page,
          per_page: itemsPerPage,
        },
      });
    }
    return {
      items: [],
      total: 0,
    };
  }

  handleFetch(query, page, itemsPerPage) {
    const items = this.selectedOccupations.filter((o: Model, index) => {
      const nameToLower = o.name ? o.name.toLowerCase() : '';
      const searchQuery = query.toLowerCase();
      return (
        nameToLower.includes(searchQuery) &&
        index + 1 > (page - 1) * itemsPerPage &&
        index + 1 <= page * itemsPerPage
      );
    });
    const total = this.selectedOccupations.length;
    return {
      items,
      total,
    };
  }

  linkOccupation(v: Model) {
    if (!this.selectedOccupations.includes(v)) {
      this.selectedOccupations.push(v);
      this.refreshList++;
    }
  }

  unlinkOccupation(v) {
    const index = this.selectedOccupations.findIndex(
      (o) => o.object_id === v.object_id
    );
    this.selectedOccupations.splice(index, 1);
    this.refreshList++;
  }

  update() {
    const occupationOids: string[] = this.selectedOccupations.map(
      (o: Model) => o.object_id || ''
    );
    this.$store.dispatch('RiskProfileTemplate/update', {
      name: this.riskProfileTemplate.name,
      description: this.riskProfileTemplate.description,
      risk_profile_items: this.enabledRiskProfileItems,
      anzsco_occupations: occupationOids,
    });
  }

  validationStep(e) {
    if (e === 0) {
      this.validateName();
    }
  }

  navigate(selected, step, done) {
    this.currentStep = step;
    done();
  }

  closeQuery() {
    this.options.query = '';
  }

  closeDialogQuery() {
    this.dialogOptions.query = '';
  }
}
